import { BaseSensorsConfig } from '@fpkg/stats-core';

export default class WebSensorsConfig extends BaseSensorsConfig {
  server_url = '';

  is_track_single_page = true; // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件

  use_client_time = true;

  send_type = 'beacon';

  source_channel = []; // 自定义渠道参数

  show_log = false; // 控制台不打印埋点相关日志

  heatmap = {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
  };

  batch_send = {
    datasend_timeout: 6000, // 一次请求超过多少毫秒的话自动取消，防止请求无响应。
    send_interval: 3000, // 间隔多少毫秒发一次数据。
    one_send_max_length: 2, // 一次请求最大发送几条数据，防止数据太大
    // 存储 localStorage 条数最大值，默认：200 。如 localStorage 条数超过该值，则使用 image 方式立即发送数据。v1.24.8 以上支持。
    storage_length: 200,
  };
}
